import * as reactQuery from '@tanstack/react-query';
import HttpQueryContext from './HttpQueryContext';
import useValidContext from '../../hooks/useValidContext';

/**
 * @type {typeof import('@tanstack/react-query').useQueries}
 */
export const useQueries = (options) => {
  useValidContext(HttpQueryContext, 'useQueries', 'HttpQueryProvider');
  return reactQuery.useQueries(options);
};

/**
 * @type {typeof import('@tanstack/react-query').useQuery}
 */
export const useQuery = (options) => {
  useValidContext(HttpQueryContext, 'useQuery', 'HttpQueryProvider');
  return reactQuery.useQuery(options);
};

/**
 * @type {typeof import('@tanstack/react-query').useQueryClient}
 */
export const useQueryClient = (options) => {
  useValidContext(HttpQueryContext, 'useQueryClient', 'HttpQueryProvider');
  return reactQuery.useQueryClient(options);
};

/**
 * @type {typeof import('@tanstack/react-query').useMutation}
 */
export const useMutation = (options) => {
  useValidContext(HttpQueryContext, 'useMutation', 'HttpQueryProvider');
  return reactQuery.useMutation(options);
};
